import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDateWithoutTime } from 'components/global/utils';
import { CustomerParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { CustomerReport } from '@api/order-reporting/types-deliveries/DeliveriesReports';
import { CustomerReportGridData } from '@pages/reporting-pages/deliveries-customer/types/CustomerReportGridData';
import { convertToGridData } from '@pages/reporting-pages/deliveries-customer/store/convertors';
import { DateRange } from '@project-types/DateRange';



interface ReportingDeliveriesCustomerState {
	gridData: CustomerReportGridData[] | null,
	dateRange: DateRange | null,
};

const initialState: ReportingDeliveriesCustomerState = {
	gridData: null,
	dateRange: null,
};



export const reportingDeliveriesCustomerSlice = createSlice({
	name: 'reportingDeliveriesCustomer',
	initialState,
	reducers: {
		createGridData: (state, action: PayloadAction<CustomerReport[] | undefined | null>) => {
			state.gridData = convertToGridData(action.payload);
		},
		setDateRange: (state, action: PayloadAction<DateRange>) => {
			state.dateRange = action.payload;
		},
		setSearchParameters: (state, action: PayloadAction<CustomerParams>) => {
			let stateFrom = state.dateRange ? state.dateRange.from : null;
			let paramFrom = action.payload.dateFrom ? getDateWithoutTime(action.payload.dateFrom) : null;
			let stateTo = state.dateRange ? state.dateRange.to : null;
			let paramTo = action.payload.dateTo ? getDateWithoutTime(action.payload.dateTo) : null;
			if (stateFrom !== paramFrom || stateTo !== paramTo) {
				state.dateRange = paramFrom && paramTo ? { from: paramFrom, to: paramTo } : null;
			}
		},
		resetStore: (_) => initialState,
	},
});



export const {
	createGridData,
	setDateRange,
	setSearchParameters,
	resetStore } = reportingDeliveriesCustomerSlice.actions;